import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export const PasswordInput = ({ value, onChange, placeholder, testId, className = "auth-input", required = true, autoFocus = false }) => {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input data-testid={testId} type={visible ? "text" : "password"} className={`${className} pr-11 w-full`}
        placeholder={placeholder} required={required} autoFocus={autoFocus}
        value={value} onChange={onChange} />
      <button type="button" data-testid={`${testId}-toggle`}
        aria-label={visible ? "Masquer le mot de passe" : "Afficher le mot de passe"}
        onClick={() => setVisible(!visible)}
        className="absolute right-0 top-0 h-full px-3 text-[#5A5A60] hover:text-black focus:text-black focus:outline-none focus-visible:ring-1 focus-visible:ring-[#FF2D95] transition-colors">
        {visible ? <EyeOff size={17} /> : <Eye size={17} />}
      </button>
    </div>
  );
};

export const passwordScore = (pw) => {
  if (!pw) return 0;
  let score = 0;
  if (pw.length >= 8) score++;
  if (pw.length >= 12) score++;
  if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) score++;
  if (/\d/.test(pw)) score++;
  if (/[^a-zA-Z0-9]/.test(pw)) score++;
  return Math.min(score, 4);
};

const LEVELS = [
  { label: "Trop court", color: "#555" },
  { label: "Faible", color: "#FF3B30" },
  { label: "Moyen", color: "#FFC107" },
  { label: "Bon", color: "#8BC34A" },
  { label: "Fort", color: "#4CAF50" },
];

export const PasswordStrength = ({ password }) => {
  if (!password) return null;
  const score = passwordScore(password);
  const lvl = LEVELS[score];
  return (
    <div data-testid="password-strength" className="flex items-center gap-2">
      <div className="flex-1 flex gap-1">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="h-1 flex-1 transition-colors"
            style={{ background: i <= score ? lvl.color : "#2a2a2a" }} />
        ))}
      </div>
      <span className="text-[10px] uppercase tracking-wider shrink-0" style={{ color: lvl.color }}>{lvl.label}</span>
    </div>
  );
};
